import * as stylex from "@stylexjs/stylex";
import { useRTL } from "../../hooks";
import { breakpoints } from "../../materials/consts.stylex";
import { themeVars } from "../../materials/theme.stylex";
import { typography } from "../../materials/typography.stylex";
const styles = {
    rootBase: {
        kVAEAm: "x10l6tqk",
        kzqmXN: "x3smdqs",
        kGO01o: "xsag5q8",
        $$css: true
    },
    rootToday: {
        k87sOh: "x1tk7jg1",
        kbCHJM: "x1c42kn3",
        $$css: true
    },
    rootTodayTransformLtr: {
        k3aq6I: "xkt2uhe x1yw7abg xt7hrd6",
        $$css: true
    },
    rootTodayTransformRtl: {
        k3aq6I: "xkt2uhe x3abc8u",
        $$css: true
    },
    rootTodayFinance: {
        kbCHJM: "x1c42kn3",
        k87sOh: "x8l1umf x1vnf2jh x1lkbrjc",
        k3aq6I: "x1dl9h40 x1yw7abg xbjrjpj",
        $$css: true
    },
    rootTimeseries: {
        k87sOh: "x1tk7jg1",
        kCIrl2: "x3m8u43",
        k3aq6I: "xo6slkr xy8y7rw",
        $$css: true
    },
    rootTimeseriesFinance: {
        kCIrl2: "x3m8u43",
        k87sOh: "xomnu4r x1r3n2zc",
        k3aq6I: "xo6slkr x1upssf1",
        $$css: true
    },
    contentBase: {
        kVAEAm: "x1n2onr6",
        kWkggS: "x14wutmr",
        kaIpWk: "x12oqio5",
        kmVPX3: "x153ncpu",
        kMwMTN: "x1awj2ng",
        kwXMNM: "x1j6awrg",
        k3foIR: "x1srwf7z",
        kbwMcY: "x86avzo",
        kXtpa: "x1dmosr7",
        k5JduY: "xs5nyxy",
        k4zj60: "x1gmr53x",
        kkgrvl: "xkj6t0a",
        kloYau: "x2q1x1w",
        kfzc6R: "x1150kdx",
        kPGmMm: "x19g77sy",
        k55e2J: "x1ru3uqb",
        $$css: true
    },
    contentTodayLtr: {
        kH8cDV: "x6sy0hq xkoaxv1 x1key6we",
        $$css: true
    },
    contentTodayRtl: {
        kH8cDV: "x6sy0hq x4cdlzc",
        $$css: true
    },
    contentTodayFinance: {
        kH8cDV: "x6sy0hq xkoaxv1",
        $$css: true
    },
    contentTimeseries: {
        kLxBhq: "xsqgl68 xajn046",
        $$css: true
    },
    contentTimeseriesFinance: {
        kLxBhq: "xsqgl68",
        $$css: true
    },
    title: {
        k63SB2: "x117nqv4",
        $$css: true
    }
};
const rootStyleFor = (position, isRTL)=>{
    switch(position){
        case "today":
            return [
                styles.rootToday,
                isRTL ? styles.rootTodayTransformRtl : styles.rootTodayTransformLtr
            ];
        case "todayFinance":
            return [
                styles.rootTodayFinance
            ];
        case "timeseries":
            return [
                styles.rootTimeseries
            ];
        case "timeseriesFinance":
            return [
                styles.rootTimeseriesFinance
            ];
    }
};
const contentStyleFor = (position, isRTL)=>{
    switch(position){
        case "today":
            return [
                isRTL ? styles.contentTodayRtl : styles.contentTodayLtr
            ];
        case "todayFinance":
            return [
                styles.contentTodayFinance
            ];
        case "timeseries":
            return [
                styles.contentTimeseries
            ];
        case "timeseriesFinance":
            return [
                styles.contentTimeseriesFinance
            ];
    }
};
export const HeroTooltip = ({ children, title, position })=>{
    const isRTL = useRTL();
    return <div {...stylex.props(styles.rootBase, ...rootStyleFor(position, isRTL))}>
      <div {...stylex.props(typography.table, styles.contentBase, ...contentStyleFor(position, isRTL))}>
        <h3 {...stylex.props(typography.table, styles.title)}>{title}</h3>
        <p>{children}</p>
      </div>
    </div>;
};
